import { useEffect, useState } from "react";
import {
    Box, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Grid, Button, IconButton, List, ListItem, ListItemAvatar, ListItemText, Tooltip, Typography
} from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import { Redirect, useParams } from "react-router-dom";
import { getApiUrl } from "../../services/api_service";
import { Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LinearProgress from '@mui/material/LinearProgress';
import NDReferralHeader from "../../components/shared/ndreferralheader";
import dayjs from "dayjs";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Footer from "../../components/shared/footer";
import { blackcolor, bodyBg, darkcolor, footerContainer, fullHeight, headerText, mainGrid, pcolor, rcolor, whitecolor } from "../../style2";
import { PostAddOutlined } from "@mui/icons-material";

export default function ReferralPatients() {
    const { orgCode } = useParams();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState([]);
    const [redirect, setRedirect] = useState('');
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [showRemovePopup, setShowRemovePopup] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const headerCellCss = { fontSize: "1.1rem", color: pcolor }
    const rowCellCss = { fontSize: "1rem", color: blackcolor }


    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/referralapp/patientlist?code=${orgCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setLoggedIn(true);
                    response.json().then(data => {
                        setResult(data);
                    });
                }
                else if (response.status === 401 || response.status === 403) {
                    setRedirect(`/referral/login/${orgCode}`);
                    setLoggedIn(false);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, []);

    const removePatientFunc = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/referralapp/removepatient?code=${orgCode}&id=${selectedId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setResult([...result.filter(t => t.id !== selectedId)]);
                    setShowRemovePopup(false);
                    setSelectedId(null);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    if (redirect !== "")
        return <Redirect to={redirect} />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader date={Date.UTC()} orgCode={orgCode} isLoggedIn={isLoggedIn} logo="../../Logo_Option_1.svg" />
            <Box pt={1} sx={{ ...bodyBg, marginTop: "5px", minHeight:"80vh" }} p={5}>
                <Grid container>
                    <Grid xs={6} item>
                        <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "1.5rem" }}>School / SENCO’S Referrals</Typography>
                    </Grid>
                    <Grid xs={6} item>
                        <Box mb={1} mt={2} style={{ textAlign: "right" }}>
                            <Button onClick={() => { setRedirect(`/referral/screenprocess/${orgCode}`); }}
                                style={{ border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.1rem", height: "40px", borderRadius: 2 }}>Make a referral</Button>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ ...mainGrid, marginTop: "20px", padding: "5px" }}>
                    {error !== "" ? <Box mb={1} mt={1}><Alert severity="error">{error}</Alert></Box> : null}
                    {success !== "" ? <Box mb={1} mt={1}><Alert severity="success">{success}</Alert></Box> : null}
                    <table style={{ width: "100%", borderRadius: "10px", border: "2px solid #fff" }}>
                        <thead>
                            <tr style={{ height: "50px", background: "#E7E7E7", borderRadius: "5px" }}>
                                <th style={headerCellCss}><Tooltip title="NHS Number"><Box>NHS <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th>
                                <th style={headerCellCss}><Tooltip title="Child/Young person’s name"><Box>Name <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th>
                                <th style={headerCellCss}><Tooltip title="Date of Birth"><Box>DOB <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th>
                                <th align="left" style={headerCellCss}>Parent/Carer Forms</th>
                                <th align="left" style={headerCellCss}>Referrar Forms</th>
                                {/* <th style={headerCellCss} ><Tooltip title="Single Point of Access Multi-Agency Referral Form"><Box>Referral Form <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th>
                                <th style={headerCellCss}>Parent/Carer Questionnaire</th>
                                <th style={headerCellCss}>Pre-school Questionnaire</th>
                                <th style={headerCellCss}><Tooltip title="Community Paediatrics For Children up to 4th Birthday"><Box>Community Paediatrics Form <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th>
                                <th style={headerCellCss}><Tooltip title="Child Young Persons School Questionnaire"><Box>Young Person School Form <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th> */}
                                <th style={headerCellCss}>Referral Status</th>
                                <th style={headerCellCss}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {result.map((item, index) => {
                                return <tr key={index} style={{ height: "50px", borderBottom: "1px solid #D9D9D9", cursor: "pointer" }}>
                                    <td align="center" style={rowCellCss} onClick={() => { setRedirect(`/referral/details/${orgCode}/${item.id}`); }}>{item.nhsNumber}</td>
                                    <td align="center" style={rowCellCss} onClick={() => { setRedirect(`/referral/details/${orgCode}/${item.id}`); }}>{item.name}</td>
                                    <td align="center" style={rowCellCss} onClick={() => { setRedirect(`/referral/details/${orgCode}/${item.id}`); }}>{dayjs(item.dob).format("DD/MM/YYYY")}</td>
                                    <td style={rowCellCss} onClick={() => { setRedirect(`/referral/details/${orgCode}/${item.id}`); }}>{item.parentForms !== null ?
                                        <List sx={{ width: '100%', maxWidth: 360 }}>
                                            {
                                                item.parentForms.map(item => {
                                                    return <ListItem style={{ padding: "5px" }}>
                                                        {item.status === 1 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: rcolor }} />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 2 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon color="info" title="Form InProgress" />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 3 || item.status === 4 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Submitted/Complete" color="success" />
                                                        </ListItemAvatar> : null}
                                                        <ListItemText primary={item.title} secondary="" />
                                                    </ListItem>;
                                                })
                                            }
                                        </List> : null}</td>
                                    <td style={rowCellCss} onClick={() => { setRedirect(`/referral/details/${orgCode}/${item.id}`); }}>
                                        {item.referrerForms !== null ? <List sx={{ width: '100%', maxWidth: 360, }}>
                                            {
                                                item.referrerForms.map(item => {
                                                    return <ListItem style={{ padding: "5px" }}>
                                                        {item.status === 1 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: rcolor }} />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 2 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon color="info" title="Form InProgress" />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 3 || item.status === 4 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Submitted/Complete" color="success" />
                                                        </ListItemAvatar> : null}
                                                        <ListItemText primary={item.title} secondary="" />
                                                    </ListItem>;
                                                })
                                            }
                                        </List> : null}
                                    </td>
                                    {/* <td align="center" style={rowCellCss}>
                                        {item.referralForm === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: "rgb(233, 30, 99)" }} /> : null}
                                        {item.referralForm === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                                        {item.referralForm === 3 || item.referralForm === 4 ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                                    </td>
                                    <td align="center" style={rowCellCss}>
                                        {item.parentForm === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: "rgb(233, 30, 99)" }} /> : null}
                                        {item.parentForm === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                                        {item.parentForm === 3 || item.parentForm === 4 ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                                    </td>
                                    <td align="center" style={rowCellCss}>
                                        {item.schoolForm !== null && item.schoolForm === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: "rgb(233, 30, 99)" }} /> : null}
                                        {item.schoolForm !== null && item.schoolForm === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                                        {item.schoolForm !== null && (item.schoolForm === 3 || item.schoolForm === 4) ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                                    </td>
                                    <td align="center" style={rowCellCss}>
                                        {item.communityPaediatrics4YearChildrenForm !== null && item.communityPaediatrics4YearChildrenForm === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: "rgb(233, 30, 99)" }} /> : null}
                                        {item.communityPaediatrics4YearChildrenForm !== null && item.communityPaediatrics4YearChildrenForm === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                                        {item.communityPaediatrics4YearChildrenForm !== null && (item.communityPaediatrics4YearChildrenForm === 3
                                            || item.communityPaediatrics4YearChildrenForm === 4) ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                                    </td>
                                    <td align="center" style={rowCellCss}>
                                        {item.youngPersonForm !== null && item.youngPersonForm === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: "rgb(233, 30, 99)" }} /> : null}
                                        {item.youngPersonForm !== null && item.youngPersonForm === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                                        {item.youngPersonForm !== null && (item.youngPersonForm === 3 || item.youngPersonForm === 4) ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                                    </td> */}
                                    <td align="center" style={rowCellCss} onClick={() => { setRedirect(`/referral/details/${orgCode}/${item.id}`); }}>
                                        <Box p={1}>
                                            {item.referralStatus > 0 ? <LinearProgress variant="determinate" style={{ height: "20px", borderRadius: "20px" }} value={item.referralStatus} color={item.isReferralComplete ? "success" : "primary"} /> : <Typography style={{ color: "rgb(233, 30, 99)" }}>Not Started</Typography>}
                                        </Box>
                                    </td>
                                    <td align="center" style={rowCellCss}>
                                        <IconButton disabled={loading}
                                            aria-label='delete'
                                            onClick={() => {
                                                setSelectedId(item.id);
                                                setShowRemovePopup(true);
                                            }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </td>
                                </tr>
                            })}
                            {!loading && result.length === 0 ? <tr><td colSpan={10}><Box p={1}>No referrals found.</Box></td></tr> : null}
                        </tbody>
                    </table>
                    {loading ? <Box pt={1} pb={2}><Typography>Loading Forms...</Typography></Box> : null}
                    <Dialog
                        open={showRemovePopup}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            Delete Referral
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <div style={{
                                    color: darkcolor,
                                    fontSize: "1.125em",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                    textAlign: "center",
                                    wordWrap: "break-word",
                                    wordBreak: "break-word", maxWidth: "500px", marginTop: "20px"
                                }}>
                                    Are you sure you want to delete this patient referral?<br /><br />
                                    This action is permanent and cannot be undone.</div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions >
                            <Button type="button" disabled={loading} style={{
                                marginBottom: "20px", backgroundColor: darkcolor, color: whitecolor, borderRadius: "9px", marginRight: "20px",
                                width: "80px"
                            }} onClick={() => { removePatientFunc(); }} autoFocus>
                                Ok
                            </Button> <Button type="button" disabled={loading} style={{
                                marginBottom: "20px", backgroundColor: darkcolor, color: whitecolor, borderRadius: "9px",

                            }} onClick={() => { setSelectedId(null); setShowRemovePopup(false); }} autoFocus>
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Box>
            <Box style={{...footerContainer, position:"static" }}>
                <Footer />
            </Box>
        </Box>
}